import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type KpiData } from '../../services/diagnosticKpiListService'

export interface DiagnosticKpiListState {
  isLoading: boolean
  kpiData: KpiData | null
  errorMessage: string | null
  httpStatus: number | null
}

const initialState: DiagnosticKpiListState = {
  isLoading: false,
  kpiData: null,
  errorMessage: null,
  httpStatus: null
}

export const diagnosticKpiListSlice = createSlice({
  name: 'diagnosticKpiList',
  initialState,
  reducers: {
    diagnosticKpiListDataLoading: (state): DiagnosticKpiListState => {
      return {
        isLoading: true,
        kpiData: null,
        errorMessage: null,
        httpStatus: 0
      }
    },
    diagnosticKpiListDataError: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>): DiagnosticKpiListState => {
      return {
        isLoading: false,
        kpiData: null,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    },
    addDiagnosticKpiListData: (state, action: PayloadAction<{ data: KpiData, httpStatus: number }>): DiagnosticKpiListState => {
      return {
        isLoading: false,
        kpiData: action.payload.data,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const { diagnosticKpiListDataLoading, diagnosticKpiListDataError, addDiagnosticKpiListData } = diagnosticKpiListSlice.actions
export default diagnosticKpiListSlice.reducer
